import { render, staticRenderFns } from "./InterestManager.vue?vue&type=template&id=0f3644a0"
import script from "./InterestManager.vue?vue&type=script&lang=js"
export * from "./InterestManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports